import React, { useLayoutEffect, useState } from 'react'
import { Modal } from 'src/components/Modal'
import ModalAccount from 'src/components/UI/Forms/OpenAccountRightForm'
import useDataLayer from 'src/hooks/useDataLayer/dataLayerBody'
import { IDataLayerParams } from 'src/hooks/useDataLayer/typesUseDataLayer'
import useDomReady from 'src/hooks/window/useDomReady'

import ImageWebp from 'src/components/ImageWebp'
import useWidth from 'src/hooks/window/useWidth'
import { WIDTH_MD } from 'src/styles/breakpoints'

import { ContentHeader, Link } from './style'

const Header = () => {
  const [ isMobile, setIsMobile ] = useState(false)
  const [ sendDatalayerEvent ] = useDataLayer()
  const [ open, setOpen ] = useState(false)
  const domReady = useDomReady()
  const url = 'https://inter-co.onelink.me/Qyu7/jzd1g4bo'

  const [ dataLayer, setDataLayer ] = useState<IDataLayerParams>({
    section: 'dobra_01',
    section_name: 'Conta Digital. Gratuita, simples e completa',
    element_name: 'Abra sua conta',
    element_action: 'click button',
    redirect_url: url,
  })

  const width = useWidth(300)

  useLayoutEffect(() => {
    setIsMobile(width < WIDTH_MD)
  }, [ width ])

  const openModal = domReady && (
    <Modal isModalOpen={open} setIsModalOpen={setOpen} locationToRender={document.body}>
      <ModalAccount
        closeModal={() => setOpen(false)} dataLayer={dataLayer}
      />
    </Modal>
  )

  return (
    <ContentHeader className='d-flex position-relative justify-content-center justify-content-lg-between'>
      {openModal}
      <div className='container'>
        <div className='row justify-content-center align-items-center'>
          <div className='col-12 col-md-6 col-lg-5 offset-lg-1 offset-xl-2 mb-4 mb-md-0 order-md-last d-none d-md-block px-xl-0'>
            <ImageWebp
              arrayNumbers={[ 0, 290, 373, 482 ]}
              arrayNumbersHeight={[ 0, 295, 380, 511 ]}
              pathSrc='https://central-imagens.bancointer.com.br/images-without-small-versions/hero-cartoes/image.webp'
              altDescription='Homem com jaqueta e fones de ouvido laranjas sorrindo'
            />
          </div>
          <div className='col-12 col-md-6 col-xl-5'>
            <h1 className='mb-3'>
              <span className='fs-24 lh-30 fs-lg-32 lh-lg-40 fs-xl-48 lh-xl-50 text-grayscale--500 fw-600 d-block'>
                Conta Digital
              </span>
              <span className='fs-24 lh-30 fs-lg-32 lh-lg-40 fs-xl-48 lh-xl-50 text-grayscale--500 fw-600 d-block mb-2'>
                Gratuita, simples e completa
              </span>
            </h1>
            <p className='fs-14 lh-17 fs-lg-16 lh-lg-20 fs-xl-18 lh-xl-22 fw-400 text-grayscale--400 mb-0'>
              Simplifique toda a sua vida com uma conta digital completa e um Super App com shopping,
              investimento, recarga e muito mais!
            </p>
            <div className='btn-div'>
              {
              isMobile ? (
                <Link
                  href={url}
                  title='Abra sua conta'
                  className='btn btn-orange--extra btn--lg rounded-2 fs-14 fw-600 text-none mb-0 mw-100'
                  onClick={() => {
                    setDataLayer(dataLayer)
                    sendDatalayerEvent(dataLayer)
                  }}
                >
                  Abra sua conta
                </Link>
              ) : (
                <button
                  className='btn btn-orange--extra btn--lg rounded-2 fs-14 fw-600 text-none mb-0 mw-100'
                  title='Abra sua conta'
                  onClick={() => {
                    setOpen(true)
                    setDataLayer(dataLayer)
                    sendDatalayerEvent({
                      section: 'dobra_01',
                      section_name: 'Conta Digital. Gratuita, simples e completa',
                      element_name: 'Abra sua conta',
                      element_action: 'click button',
                    })
                  }}
                >
                  Abra sua conta
                </button>
              )
            }
            </div>
          </div>
        </div>
      </div>
    </ContentHeader>
  )
}

export default Header
